<template>
  <!--
   This example requires some changes to your config:

   ```
   // tailwind.config.js
   module.exports = {
     // ...
     plugins: [
       // ...
       require('@tailwindcss/forms'),
     ],
   }
   ```
 -->
  
<div class="relative ">
 <div v-if="loading" class="absolute top-0 left-0  h-full w-full z-0 flex items-center justify-center">
   <div class="bg-white opacity-80 h-full w-full absolute"></div>
   <div class="text-4xl text-gray-300 z-30">
     <i class="fal fa-circle-notch fa-spin"></i>
   </div>

 </div>
 <div class="relative z-10" role="dialog" aria-modal="true" v-if="showQuickView">
   <!--
     Background backdrop, show/hide based on modal state.

     Entering: "ease-out duration-300"
       From: "opacity-0"
       To: "opacity-100"
     Leaving: "ease-in duration-200"
       From: "opacity-100"
       To: "opacity-0"
   -->


   <div class="fixed inset-0  w-screen overflow-y-auto">
     <div @click="hideQuickView()"
          class="fixed inset-0 hidden bg-gray-500 bg-opacity-50 transition-opacity md:block z-10"
          aria-hidden="true"></div>
     <div class="flex min-h-full items-stretch justify-center text-center md:items-center md:px-2 lg:px-4 relative">
       <!--
         Modal panel, show/hide based on modal state.

         Entering: "ease-out duration-300"
           From: "opacity-0 translate-y-4 md:translate-y-0 md:scale-95"
           To: "opacity-100 translate-y-0 md:scale-100"
         Leaving: "ease-in duration-200"
           From: "opacity-100 translate-y-0 md:scale-100"
           To: "opacity-0 translate-y-4 md:translate-y-0 md:scale-95"
       -->
       <div
           class="flex w-full transform text-left text-base transition md:my-8 md:max-w-2xl md:px-4 lg:max-w-4xl quick-view-container z-50"
           ref="quickViewContainer">
         <div class="h-full flex flex-col items-center justify-center absolute z-50 left-0 -ml-4">
           <div @click="previousEvent?showAndLoadQuickView(previousEvent):null"
                class="bg-white  shadow-md rounded-lg overflow-hidden p-3 "
                :class="{'transition transform hover:scale-105  hover:bg-gray-50 cursor-pointer opacity-100':previousEvent,
           'opacity-0':!previousEvent}"
           >
             <i class="fal fa-chevron-left text-3xl"></i>
           </div>
         </div>
         <div
             class="h-full flex flex-col items-center justify-center absolute z-50 right-0 ml-4 transition transform ease-in-out duration-300">
           <div @click="nextEvent?showAndLoadQuickView(nextEvent):null"
                class="bg-white  shadow-md rounded-lg overflow-hidden p-3 "
                :class="{'transition transform hover:scale-105  hover:bg-gray-50 cursor-pointer opacity-100':nextEvent,
           'opacity-0':!nextEvent}"
           >
             <i class="fal fa-chevron-right text-3xl"></i>
           </div>
         </div>

         <div
             class="relative flex w-full items-center  bg-white shadow-2xl rounded-md transition transform ease-in-out duration-300">
           <button @click="hideQuickView()" type="button"
                   class="isolate absolute z-50 -mt-4 -mr-4 right-0 top-0 text-gray-400 hover:text-gray-500 sm:right-6 sm:top-8 md:right-6 md:top-6 lg:right-8 lg:top-8">
             <span class="sr-only">Close</span>
             <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                  aria-hidden="true" data-slot="icon">
               <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
             </svg>
           </button>
           <div class="relative w-full">

             <div v-if="quickViewLoading"
                  class="absolute bg-white bg-opacity-50 h-full text-4xl z-50 p-8 flex justify-center items-center w-full text-gray-400 duration-500 transition transform">
               <i class="fal fa-circle-notch fa-spin text-primary-500"></i></div>

             <custom-runtime-template v-if="quickViewHtml" :template="quickViewHtml" :context="quickViewContext"/>
           </div>

         </div>
       </div>
     </div>
   </div>
 </div>
 <div>
   <!--
     Mobile filter dialog

     Off-canvas filters for mobile, show/hide based on off-canvas filters state.
   -->
   <transition enter-active-class="transition ease-in-out duration-300 transform"
               enter-from-class="translate-x-full" enter-to-class="translate-x-0"
               leave-active-class="transition ease-in-out duration-300 transform"
               leave-from-class="translate-x-0" leave-to-class="translate-x-full">


     <div class="relative z-40 lg:hidden" role="dialog" aria-modal="true" v-if="menus.mobileFilters">
       <!--
         Off-canvas menu backdrop, show/hide based on off-canvas menu state.

         Entering: "transition-opacity ease-linear duration-300"
           From: "opacity-0"
           To: "opacity-100"
         Leaving: "transition-opacity ease-linear duration-300"
           From: "opacity-100"
           To: "opacity-0"
       -->

       <div class="fixed inset-0 z-40 flex">
         <div class="fixed inset-0 bg-black bg-opacity-25" @click="menus.mobileFilters=false"
              aria-hidden="true"></div>

         <!--
           Off-canvas menu, show/hide based on off-canvas menu state.

           Entering: "transition ease-in-out duration-300 transform"
             From: "translate-x-full"
             To: "translate-x-0"
           Leaving: "transition ease-in-out duration-300 transform"
             From: "translate-x-0"
             To: "translate-x-full"
         -->
         <div
             class="relative ml-auto flex h-full w-full max-w-xs flex-col overflow-y-auto bg-white py-4 pb-12 shadow-xl">
           <div class="flex items-center justify-between px-4">
             <h2 class="text-lg font-medium text-gray-900">Filters</h2>
             <button type="button" @click="menus.mobileFilters=false"
                     class="-mr-2 flex h-10 w-10 items-center justify-center rounded-md bg-white p-2 text-gray-400">
               <span class="sr-only">Close menu</span>
               <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                    aria-hidden="true" data-slot="icon">
                 <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
               </svg>
             </button>
           </div>

           <!-- Filters -->
           <form class="mt-4 border-t border-gray-200 p-2">
             <h3 class="sr-only">Categories</h3>
             <ul v-if="false" role="list" class="px-2 py-3 font-medium text-gray-900"> <!-- Changed true==false to false -->
               <li>
                 <a href="#" class="block px-2 py-3">Totes</a>
               </li>
               <li>
                 <a href="#" class="block px-2 py-3">Backpacks</a>
               </li>
               <li>
                 <a href="#" class="block px-2 py-3">Travel Bags</a>
               </li>
               <li>
                 <a href="#" class="block px-2 py-3">Hip Bags</a>
               </li>
               <li>
                 <a href="#" class="block px-2 py-3">Laptop Sleeves</a>
               </li>
             </ul>



             <div class="border-b border-gray-200 py-6" v-for="filter in availableFilterTags" :key="filter.id">
               <h3 class="-my-3 flow-root">
                 <!-- Expand/collapse section button -->
                 <button type="button"
                         @click="menus['filter_'+filter.id] = !menus['filter_'+filter.id]"
                         class="flex w-full items-center justify-between bg-white py-2 text-sm text-gray-400 hover:text-gray-500"
                         aria-controls="filter-section-0" aria-expanded="false">
                 <span class="font-medium text-gray-900">{{ translateField(filter.name) }} <span
                     class="bg-gray-100 text-gray-600 rounded-md px-1 py-0.5 text-xxs font-bold ml-1"
                     v-if="getTagLength(filter.descendants)>0"><i
                     class="fal fa-filter"></i> {{ getTagLength(filter.descendants) }}</span></span>
                   <span class="ml-6 flex items-center">
                 <!-- Expand icon, show/hide based on section open state. -->
                 <svg class="h-5 w-5" v-if="!menus['filter_'+filter.id]" viewBox="0 0 20 20" fill="currentColor"
                      aria-hidden="true" data-slot="icon">
                   <path
                       d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"/>
                 </svg>
                     <!-- Collapse icon, show/hide based on section open state. -->
                 <svg class="h-5 w-5" v-if="menus['filter_'+filter.id]" viewBox="0 0 20 20" fill="currentColor"
                      aria-hidden="true" data-slot="icon">
                   <path fill-rule="evenodd"
                         d="M4 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 10Z"
                         clip-rule="evenodd"/>
                 </svg>
               </span>
                 </button>
               </h3>
               <!-- Filter section, show/hide based on section state. -->

               <transition
                   @enter="enter"
                   @leave="leave"
                   enter-active-class="transition ease-out duration-100"
                   enter-from-class="transform opacity-0 scale-y-0"
                   enter-to-class="transform opacity-100 scale-y-100"
                   leave-active-class="transition ease-in duration-100"
                   leave-from-class="transform opacity-100 scale-y-100"
                   leave-to-class="transform opacity-0 scale-y-0 ">

                 <div v-show="menus['filter_'+filter.id]" class="pt-6 origin-top" id="filter-section-0">

                   <div class="space-y-3">
                     <div class="flex items-center transition duration-300" v-for="tag in filter.descendants"
                          :key="tag.id" :class="{'opacity-25':!checkIfFilteredEventsHaveTagId(tag.id)}">
                       <input @change="removeFiltersNotMatchingEvents()" :id="'filter-tag-'+tag.id"
                              v-model="filterTags[filter.id]" :value="tag.id" type="checkbox"
                              :disabled="!checkIfFilteredEventsHaveTagId(tag.id)"
                              class="h-4 w-4 rounded border-gray-300 text-primary-500 focus:ring-primary-400">
                       <label :for="'filter-tag-'+tag.id" class="ml-3 text-sm text-gray-600 leading-tight"
                              v-text="translateField(tag.name)"></label>
                     </div>

                   </div>
                 </div>
               </transition>
             </div>
             <div class="border-b border-gray-200 py-6">
               <h3 class="-my-3 flow-root">
                 <!-- Expand/collapse section button -->
                 <button type="button" @click="menus.filterEventType=!menus.filterEventType"
                         class="flex w-full items-center justify-between bg-white py-2 text-sm text-gray-400 hover:text-gray-500"
                         aria-controls="filter-section-0" aria-expanded="false">
                 <span class="font-medium text-gray-900">{{ getLabel('event_type') }} <span
                     class="bg-gray-100 text-gray-600 rounded-md px-1 py-0.5 text-xxs font-bold ml-1"
                     v-if="filterEventTypes.length>0"><i
                     class="fal fa-filter"></i> {{ filterEventTypes.length }}</span></span>
                   <span class="ml-6 flex items-center">
                 <!-- Expand icon, show/hide based on section open state. -->
                 <svg v-if="!menus.filterEventType" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"
                      aria-hidden="true" data-slot="icon">
                   <path
                       d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"/>
                 </svg>
                     <!-- Collapse icon, show/hide based on section open state. -->
                 <svg v-if="menus.filterEventType" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"
                      aria-hidden="true" data-slot="icon">
                   <path fill-rule="evenodd"
                         d="M4 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 10Z"
                         clip-rule="evenodd"/>
                 </svg>
               </span>
                 </button>
               </h3>
               <!-- Filter section, show/hide based on section state. -->

               <transition
                   @enter="enter"
                   @leave="leave"
                   enter-active-class="transition ease-out duration-100"
                   enter-from-class="transform opacity-0 scale-y-0"
                   enter-to-class="transform opacity-100 scale-y-100"
                   leave-active-class="transition ease-in duration-100"
                   leave-from-class="transform opacity-100 scale-y-100"
                   leave-to-class="transform opacity-0 scale-y-0 ">

                 <div v-show="menus.filterEventType" class="pt-6 origin-top" id="filter-section-0">
                   <div class="space-y-3">
                     <div class="flex items-center transition duration-300" v-for="eventType in eventTypes"
                          :key="eventType.id"
                          :class="{'opacity-25':!checkIfFilteredEventsHaveEventType(eventType.id)}">
                       <input :id="'filter-event-type-'+eventType.id" v-model="filterEventTypes"
                              :value="eventType.id"
                              type="checkbox"
                              class="h-4 w-4 rounded border-gray-300 text-primary-500 focus:ring-primary-400">
                       <label :for="'filter-event-type-'+eventType.id" class="ml-3 text-sm text-gray-600 w-full"
                              v-text="translateField(eventType.display_name_localizations)"></label>
                     </div>

                   </div>
                 </div>
               </transition>
             </div>
           </form>
         </div>

       </div>
     </div>
   </transition>

   <main class="mx-auto max-w-none container px-4 md:px-1">
     <div class="flex items-baseline justify-between border-b border-gray-200 pb-6 pt-4">
       <h1 class="text-base font-bold tracking-tight text-gray-900"></h1>

       <div class="flex items-center">
         <div class="relative inline-block text-left">
           <div>
             <button @click="menus.sort=!menus.sort" type="button"
                     class="group inline-flex justify-center text-sm font-medium text-primary-500 hover:text-gray-900"
                     id="menu-button" aria-expanded="false" aria-haspopup="true">
               {{ currentSortName }}
               <svg class="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                    viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                 <path fill-rule="evenodd"
                       d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                       clip-rule="evenodd"/>
               </svg>
             </button>
           </div>

           <!--
             Dropdown menu, show/hide based on menu state.

             Entering: "transition ease-out duration-100"
               From: "transform opacity-0 scale-95"
               To: "transform opacity-100 scale-100"
             Leaving: "transition ease-in duration-75"
               From: "transform opacity-100 scale-100"
               To: "transform opacity-0 scale-95"
           -->
           <transition enter-active-class="transition ease-out duration-100"
                       enter-from-class="transform opacity-0 scale-95"
                       enter-to-class="transform opacity-100 scale-100"
                       leave-active-class="transition ease-in duration-75"
                       leave-from-class="transform opacity-100 scale-100"
                       leave-to-class="transform opacity-0 scale-95">
             <div v-if="menus.sort"
                  class="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white shadow-2xl ring-1 ring-black ring-opacity-5 focus:outline-none"
                  role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
               <div class="py-1" role="none">
                 <!--
                   Active: "bg-gray-100", Not Active: ""

                   Selected: "font-medium text-gray-900", Not Selected: "text-gray-500"
                 -->
                 <a class="block cursor-pointer px-4 py-2 text-sm font-medium text-gray-900" role="menuitem"
                    tabindex="-1"
                    id="menu-item-0"
                    @click="sortBy=sortOption.field;menus.sort=false"
                    v-for="sortOption in sortOptions" :key="sortOption.id"
                    :class="{'font-bold bg-gray-50':sortBy==sortOption.field,'font-medium ':!sortBy==sortOption.field}">{{
                     sortOption.name
                   }}</a>

               </div>
             </div>
           </transition>
         </div>

         <button v-if="false" type="button" class="-m-2 ml-5 p-2 text-gray-400 hover:text-gray-500 sm:ml-7"> <!-- Changed true==false to false -->
           <span class="sr-only">View grid</span>
           <svg class="h-5 w-5" aria-hidden="true" viewBox="0 0 20 20" fill="currentColor" data-slot="icon">
             <path fill-rule="evenodd"
                   d="M4.25 2A2.25 2.25 0 0 0 2 4.25v2.5A2.25 2.25 0 0 0 4.25 9h2.5A2.25 2.25 0 0 0 9 6.75v-2.5A2.25 2.25 0 0 0 6.75 2h-2.5Zm0 9A2.25 2.25 0 0 0 2 13.25v2.5A2.25 2.25 0 0 0 4.25 18h2.5A2.25 2.25 0 0 0 9 15.75v-2.5A2.25 2.25 0 0 0 6.75 11h-2.5Zm9-9A2.25 2.25 0 0 0 11 4.25v2.5A2.25 2.25 0 0 0 13.25 9h2.5A2.25 2.25 0 0 0 18 6.75v-2.5A2.25 2.25 0 0 0 15.75 2h-2.5Zm0 9A2.25 2.25 0 0 0 11 13.25v2.5A2.25 2.25 0 0 0 13.25 18h2.5A2.25 2.25 0 0 0 18 15.75v-2.5A2.25 2.25 0 0 0 15.75 11h-2.5Z"
                   clip-rule="evenodd"/>
           </svg>
         </button>
         <button @click="menus.mobileFilters=!menus.mobileFilters" type="button"
                 class="-m-2 ml-4 p-2 text-gray-400 hover:text-gray-500 sm:ml-6 lg:hidden">
           <span class="sr-only">Filters</span>
           <svg class="h-5 w-5" aria-hidden="true" viewBox="0 0 20 20" fill="currentColor" data-slot="icon">
             <path fill-rule="evenodd"
                   d="M2.628 1.601C5.028 1.206 7.49 1 10 1s4.973.206 7.372.601a.75.75 0 0 1 .628.74v2.288a2.25 2.25 0 0 1-.659 1.59l-4.682 4.683a2.25 2.25 0 0 0-.659 1.59v3.037c0 .684-.31 1.33-.844 1.757l-1.937 1.55A.75.75 0 0 1 8 18.25v-5.757a2.25 2.25 0 0 0-.659-1.591L2.659 6.22A2.25 2.25 0 0 1 2 4.629V2.34a.75.75 0 0 1 .628-.74Z"
                   clip-rule="evenodd"/>
           </svg>
           <span v-if="totalFilters>0"
                 class="top-0 right-0 absolute bg-red-200 bg-text-red-600 px-1 py-0 text-xs rounded-md mr-2 mt-2">
             {{ totalFilters }}
           </span>
         </button>
       </div>
     </div>

     <section aria-labelledby="products-heading" class="pb-24 pt-6">
       <h2 id="products-heading" class="sr-only">Products</h2>

       <div class="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-4 relative">
         <!-- Filters -->
         <div class="hidden lg:block bg-white">
           <div class="sticky top-0 max-h-screen overflow-y-scroll">
             <h3 class="sr-only">Categories</h3>


             <div class="border-b border-gray-200 py-6" v-for="filter in availableFilterTags" :key="filter.id">
               <h3 class="-my-3 flow-root">
                 <!-- Expand/collapse section button -->
                 <button type="button"
                         @click="menus['filter_'+filter.id] = !menus['filter_'+filter.id]"
                         class="flex w-full items-center justify-between bg-white py-2 text-sm text-gray-400 hover:text-gray-500"
                         aria-controls="filter-section-0" aria-expanded="false">
                 <span class="font-medium text-gray-900">{{ translateField(filter.name) }} <span
                     class="bg-gray-100 text-gray-600 rounded-md px-1 py-0.5 text-xxs font-bold ml-1"
                     v-if="getTagLength(filter.descendants)>0"><i
                     class="fal fa-filter"></i> {{ getTagLength(filter.descendants) }}</span></span>
                   <span class="ml-6 flex items-center">
                 <!-- Expand icon, show/hide based on section open state. -->
                 <svg class="h-5 w-5" v-if="!menus['filter_'+filter.id]" viewBox="0 0 20 20" fill="currentColor"
                      aria-hidden="true" data-slot="icon">
                   <path
                       d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"/>
                 </svg>
                     <!-- Collapse icon, show/hide based on section open state. -->
                 <svg class="h-5 w-5" v-if="menus['filter_'+filter.id]" viewBox="0 0 20 20" fill="currentColor"
                      aria-hidden="true" data-slot="icon">
                   <path fill-rule="evenodd"
                         d="M4 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 10Z"
                         clip-rule="evenodd"/>
                 </svg>
               </span>
                 </button>
               </h3>
               <!-- Filter section, show/hide based on section state. -->

               <transition
                   @enter="enter"
                   @leave="leave"
                   enter-active-class="transition ease-out duration-100"
                   enter-from-class="transform opacity-0 scale-y-0" enter-to-class="transform opacity-100 scale-y-100"
                   leave-active-class="transition ease-in duration-100"
                   leave-from-class="transform opacity-100 scale-y-100"
                   leave-to-class="transform opacity-0 scale-y-0 ">

                 <div v-show="menus['filter_'+filter.id]" class="pt-6 origin-top" id="filter-section-0">

                   <div class="space-y-3">
                     <div class="flex items-center transition duration-300" v-for="tag in filter.descendants"
                          :key="tag.id" :class="{'opacity-25':!checkIfFilteredEventsHaveTagId(tag.id)}">
                       <input @change="removeFiltersNotMatchingEvents()" :id="'filter-tag-'+tag.id"
                              v-model="filterTags[filter.id]" :value="tag.id" type="checkbox"
                              :disabled="!checkIfFilteredEventsHaveTagId(tag.id)"
                              class="h-4 w-4 rounded border-gray-300 text-primary-500 focus:ring-primary-400">
                       <label :for="'filter-tag-'+tag.id" class="ml-3 text-sm text-gray-600 leading-tight"
                              v-text="translateField(tag.name)"></label>
                     </div>

                   </div>
                 </div>
               </transition>
             </div>
             <div class="border-b border-gray-200 py-6">
               <h3 class="-my-3 flow-root">
                 <!-- Expand/collapse section button -->
                 <button type="button" @click="menus.filterEventType=!menus.filterEventType"
                         class="flex w-full items-center justify-between bg-white py-2 text-sm text-gray-400 hover:text-gray-500"
                         aria-controls="filter-section-0" aria-expanded="false">
                 <span class="font-medium text-gray-900">{{ getLabel('event_type') }} <span
                     class="bg-gray-100 text-gray-600 rounded-md px-1 py-0.5 text-xxs font-bold ml-1"
                     v-if="filterEventTypes.length>0"><i
                     class="fal fa-filter"></i> {{ filterEventTypes.length }}</span></span>
                   <span class="ml-6 flex items-center">
                 <!-- Expand icon, show/hide based on section open state. -->
                 <svg v-if="!menus.filterEventType" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"
                      aria-hidden="true" data-slot="icon">
                   <path
                       d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"/>
                 </svg>
                     <!-- Collapse icon, show/hide based on section open state. -->
                 <svg v-if="menus.filterEventType" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor"
                      aria-hidden="true" data-slot="icon">
                   <path fill-rule="evenodd"
                         d="M4 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 10Z"
                         clip-rule="evenodd"/>
                 </svg>
               </span>
                 </button>
               </h3>
               <!-- Filter section, show/hide based on section state. -->

               <transition
                   @enter="enter"
                   @leave="leave"
                   enter-active-class="transition ease-out duration-100"
                   enter-from-class="transform opacity-0 scale-y-0" enter-to-class="transform opacity-100 scale-y-100"
                   leave-active-class="transition ease-in duration-100"
                   leave-from-class="transform opacity-100 scale-y-100"
                   leave-to-class="transform opacity-0 scale-y-0 ">

                 <div v-show="menus.filterEventType" class="pt-6 origin-top" id="filter-section-0">
                   <div class="space-y-3">
                     <div class="flex items-center transition duration-300" v-for="eventType in eventTypes"
                          :key="eventType.id"
                          :class="{'opacity-25':!checkIfFilteredEventsHaveEventType(eventType.id)}">
                       <input :id="'filter-event-type-'+eventType.id" v-model="filterEventTypes" :value="eventType.id"
                              type="checkbox"
                              class="h-4 w-4 rounded border-gray-300 text-primary-500 focus:ring-primary-400">
                       <label :for="'filter-event-type-'+eventType.id" class="ml-3 text-sm text-gray-600"
                              v-text="translateField(eventType.display_name_localizations)"></label>
                     </div>

                   </div>
                 </div>
               </transition>
             </div>
           </div>



         </div>

         <!-- Product grid -->
         <div class="lg:col-span-3">
           <transition-group name="list" tag="div"
                             class="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 "
                             v-if="filteredEvents.length>0">
             <a  @click="isMobile!='ban'?null:showAndLoadQuickView(item)" @mouseenter="selectedId=item.id" @mouseleave="selectedId=null"
                  :href="isMobile!='ban'?(translateField(item.url)?translateField(item.url):'#'):null" class="col-span-1 flex flex-col text-center bg-white
   rounded-md  relative cursor-pointer
transform transition-all duration-200 ease-in-out
"
                  :class="{'cursor-default':!translateField(item.url),'ring-2 ring-primary-300':quickViewEvent && quickViewEvent.id==item.id,' hover:scale-105 shadow-lg ':translateField(item.url)}"
                  v-for="item in filteredEvents" :key="item.id">

               <div class="absolute w-full z-0 bg-white  h-full rounded-md"
                    :style="{'background': 'url('+item.backgroundImage.md+') center center / cover no-repeat'}"
                    style="mask-image: linear-gradient(to bottom right, rgba(0,0,0,.05) 40%, rgba(0,0,0,.2) 90%);"
                    v-if="item.backgroundImage"></div>

               <div class="absolute flex justify-center w-full z-10">


                 <div
                     class=" top-0 whitespace-nowrap -mt-2 shadow-sm  rounded px-1.5 py-0.5  text-xs mx-auto font-medium text-gray-600 bg-gray-50 relative z-10">

         <span class="font-mono font-bold" v-if="item.key_status_id!=67">
           <i class="fal fa-calendar-alt mr-1"></i> {{ item.localizedStartDateString }}
         </span>
                   <span class="font-mono" v-if="item.key_status_id==67">
           <i :class="item.key_status.icon" class="fal mr-1"></i> {{ item.key_status.localized_display_name }}
         </span>

                 </div>


               </div>

               <div class="flex-1 flex flex-col p-4  relative z-10">


                 <h3 class="mt-1.5 text-gray-800 text-xs font-light relative">

                   <i class="fal" :class="item.key_type.icon"></i>

                   {{ item.key_type.display_name }}</h3>
                 <h3 class="mt-0.5 text-gray-900 text-sm font-medium leading-none relative"
                     style="text-wrap: pretty;">
                   <div class="absolute top-0 left-0 bg-white opacity-80 h-full w-full z-0"
                        style="filter: blur(30px);"></div>
                   <div style="font-size: 0.95rem;     line-height: 1.07rem;" class="relative z-20 text-base leading-4 my-1 font-semibold">{{ translateField(item.name) }}</div></h3>
                 <h4 class="mt-0.5 text-gray-900 text-sm font-normal leading-none relative"
                     style="text-wrap: pretty;">

                   <span class="relative z-20 ">{{ translateField(item.subname) }}</span></h4>
                 <dl class="mt-0.5 flex-grow flex justify-center items-end flex-wrap">
                   <div class="">
                     <dd class="text-gray-800 text-xs w-full relative" v-if="item.key_status_id!=67">
                       {{ item.localizedTimeString }}
                     </dd>

                     <dd class="text-gray-800 text-xs w-full relative" v-if="item.default_language">
                       <i class="fal fa-language mr-1"></i> {{ item.default_language.display_name }}
                     </dd>

                     <dd class="text-gray-700 text-xs opacity-80 space-x-1 relative font-medium mt-1">
                       <div v-if="item.on_site"
                            class="inline-flex border border-gray-100 px-1 py-0.5 rounded-md bg-gray-50 items-center justify-center text-xxs relative">
                         <i class="fal fa-location-pin mr-1"></i> {{ item.localizedCity }}
                       </div>
                       <div v-if="item.online"
                            class="inline-flex border border-gray-100 px-1 py-0.5 rounded-md bg-gray-50 items-center justify-center text-xxs relative">
                         <i class="fal fa-globe mr-1"></i> online
                       </div>

                     </dd>

                   </div>


                 </dl>

               </div>

             </a>

           </transition-group>

         </div>
       </div>
     </section>
   </main>
 </div>
</div>


</template>

<script>

import axios from 'axios';
import _ from 'lodash';
import CustomRuntimeTemplate from '../../Components/CustomRuntimeTemplate.vue';

export default {
name: 'EventBrowser',
components: {CustomRuntimeTemplate},
data() {
 return {
   loading: false,
   showQuickView: false,
   quickViewHtml: null,
   quickViewEvent: null,
   quickViewLoading: false,

   sortOptions: [],
   sortBy: 'start_date',
   calender: {},
   labels: {},
   menus: {
     sort: false,
     filterEventType: false,
     mobileFilters: false
   },
   selectedId: null,
   filterEventTypes: [],
   filterTags: {},
 };
},

methods: {

 getLabel(key) {
   return this.labels[key] || '-';
 },

 checkIfFilteredEventsHaveTagId(tagId) {
   //Check if filteredEvents have tag
   return this.filteredEvents.filter(event => event.tagIdsArray.includes(tagId)).length > 0
 },

 showAndLoadQuickView(event) {
   this.quickViewEvent = event;
   this.showQuickView = true;
   this.quickViewLoading = true;
   console.log('Loading quick view for event:', event);
   axios.get(this.quickViewEvent.preview_ajax_url).then(response => {
     console.log('Quick view response:', response.data);
     this.quickViewHtml = response.data.html;
     console.log('Quick view HTML set:', this.quickViewHtml);
   }).catch(error => {
     console.error('Quick view error:', error);
   }).finally(() => {
     this.quickViewLoading = false;
   });

 },
 hideQuickView() {
   this.showQuickView = false;
   this.quickViewHtml = null;
 },
 handleKeydown(event) {
   if (!this.quickViewEvent) {
     return;
   }
   if (event.key === 'ArrowRight' && this.nextEvent) {
     this.showAndLoadQuickView(this.nextEvent);
   } else if (event.key === 'ArrowLeft' && this.previousEvent) {
     this.showAndLoadQuickView(this.previousEvent);
   }
 },

 checkIfFilteredEventsHaveEventType(eventTypeId) {
   //Check if filteredEvents have tag
   return this.filteredEventsByTag.filter(event => event.key_type.id === eventTypeId).length > 0
 },


 getTagLength(tags) {
   let allFilteredTags = _.flatten(_.values(this.filterTags))
   return _.intersection(allFilteredTags, _.map(tags, 'id')).length
 },
 translateField(data) {
   var appLanguage = "de"; // Default
   if (window.appSettings && window.appSettings.appLanguage) {
      appLanguage = window.appSettings.appLanguage;
   }

   if (typeof data === 'undefined' || data === null) {
     return '';
   }
   if (typeof data[appLanguage] !== 'undefined') {
     return data[appLanguage];
   }
   if (typeof data['A0'] !== 'undefined') { // Fallback to 'A0'
     return data['A0'];
   }
   if (typeof data !== 'object') {
     return data;
   }

   return ''
 },
 enter(el) {
   el.style.height = '0';
   el.style.overflow = 'hidden';
   el.style.transition = 'height 300ms ease-in-out'; // Use a fixed duration or get from CSS
   requestAnimationFrame(() => {
     el.style.height = el.scrollHeight + 'px';
     el.addEventListener('transitionend', () => {
       el.style.height = 'auto';
       el.style.overflow = '';
       el.style.transition = '';
     }, {once: true});
   });
 },
 leave(el) {
   const height = el.scrollHeight;
   el.style.height = height + 'px';
   el.style.overflow = 'hidden';
   el.style.transition = 'height 300ms ease-in-out'; // Use a fixed duration or get from CSS
   requestAnimationFrame(() => {
     el.style.height = '0';
     el.addEventListener('transitionend', () => {
       el.style.overflow = '';
       el.style.transition = '';
     }, {once: true});
   });
 },
 removeFiltersNotMatchingEvents() {
   // Remove filter ids that do not match any events
   for (const [key, value] of Object.entries(this.filterTags)) {
     if (Array.isArray(value) && value.length > 0) {
       this.filterTags[key] = value.filter(tagId =>
           this.filteredEvents.some(event => event.tagIdsArray.includes(tagId))
       );
     }
   }
 }
},
mounted() {
 let lang = "de"
 if (window.appSettings && window.appSettings.appLanguage) {
   lang = window.appSettings.appLanguage
 }

 this.loading = true;
 axios.get('https://' + this.domain + '/api/customer/widget/calender/v2/' + "?lang=" + lang).then(response => {
   _(response.data.filters).each((filter) => {
     // Vue 3 reactivity: Direct assignment is fine for adding properties to objects declared in data
     this.menus['filter_' + filter.id] = false;
     this.filterTags[filter.id] = [];
   })
   
   this.sortOptions = response.data.sorting_options;
   this.labels = response.data.labels;
   
   this.calender = response.data;

   if (this.selectedEventTypes.length > 0) {
      this.filterEventTypes = this.selectedEventTypes.filter(eventTypeId => 
         this.eventTypes.find(eventType => eventType.id === eventTypeId)
      );
   }
   if (this.selectedTags.length > 0) {
     this.selectedTags.forEach(tagId => {
       let filter = this.availableFilterTags.find(f => f.descendants.find(tag => tag.id === tagId))
       if (filter) {
         if (!this.filterTags[filter.id]) { // Ensure array exists
             this.filterTags[filter.id] = [];
         }
         this.filterTags[filter.id].push(tagId);
       }
     })
   }
   this.loading = false;
 }).catch(error => {
   console.log(error);
   this.loading = false;
 });

 window.addEventListener('keydown', this.handleKeydown);

},
beforeUnmount() { // Changed from beforeDestroy
 window.removeEventListener('keydown', this.handleKeydown);
},
watch: {},
props: {
 domain: {
   type: String,
   default: 'dgm.inventum.de'
 },
 selectedEventTypes: {
   type: Array,
   default: () => []
 },
 selectedTags: {
   type: Array,
   default: () => []
 }
},
computed: {
 isMobile() {
   if (typeof window !== 'undefined') {
     return window.innerWidth < 1024;
   }
   return false; // Or a default server-side behavior
 },
 totalFilters() {
   return _(this.availableFilterTags)
     .map('descendants')
     .map(tags => this.getTagLength(tags))
     .sum() + this.filterEventTypes.length;
 },
 currentSortName() {
   let sortOption = this.sortOptions.find(option => option.field === this.sortBy)
   if (sortOption) {
     return sortOption.name
   }
   return ''
 },
 previousEvent() {
   if (!this.quickViewEvent || !this.quickViewEvent.id) {
     return null
   }
   let index = this.filteredEvents.findIndex(event => event.id === this.quickViewEvent.id)
   if (index > 0) {
     return this.filteredEvents[index - 1]
   }
   return null
 },
 nextEvent() {
   if (!this.quickViewEvent || !this.quickViewEvent.id) {
     return null
   }
   let index = this.filteredEvents.findIndex(event => event.id === this.quickViewEvent.id)
   if (index < this.filteredEvents.length - 1) {
     return this.filteredEvents[index + 1]
   }
   return null
 },
 events() {
   if (this.calender.calendar) {
     return this.calender.calendar;
   } else {
     return [];
   }
 },
 filteredEventsByTag() {
   return this.events.filter(event => {
     for (const [key, value] of Object.entries(this.filterTags)) {
       if (!Array.isArray(value) || value.length === 0) { // Ensure value is an array
         continue;
       }
       if (!event.tagIdsArray) {
         return false;
       }
       if (!_.intersection(value, event.tagIdsArray).length > 0) {
         return false;
       }
     }
     return true;
   })
 },
 filteredEvents() {
   let events = this.events.filter(event => {
     if (this.filterEventTypes.length > 0 && !this.filterEventTypes.includes(event.key_type.id)) {
       return false;
     }
     for (const [key, value] of Object.entries(this.filterTags)) {
        if (!Array.isArray(value) || value.length === 0) { // Ensure value is an array
         continue;
       }
       if (!event.tagIdsArray) {
         return false;
       }
       if (!_.intersection(value, event.tagIdsArray).length > 0) {
         return false;
       }
     }
     return true;
   })
   return _.sortBy(events, this.sortBy)
 },
 eventTypes() {
   // Ensure events is processed safely
   if (!this.events || this.events.length === 0) return [];
   return _(this.events).map('key_type').filter(kt => kt && kt.id).keyBy('id').sortBy('display_name').value()
 },
 availableFilterTags() {
   if (!this.calender.filters) {
     return []
   }
   // Ensure name.A0 exists for sorting, or provide a fallback
   return _(this.calender.filters)
     .uniqBy('id')
     .sortBy(f => (f.name && f.name.A0) ? f.name.A0 : '') 
     .value();
 },
 quickViewContext() {
   return {
     // Current event data
     event: this.quickViewEvent,
     // Utility methods
     translateField: this.translateField,
     getLabel: this.getLabel,
     // Component data that might be needed
     labels: this.labels,
     // Date/time helpers
     Date: Date,
     moment: window.moment || (() => new Date()),
     // Any other data that might be referenced in the quick view template
     ...this.$data
   };
 }

}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.list-enter-active,
.list-leave-active,
.list-move {
transition: 400ms ease-in-out;
transition-property: all;
}

.list-enter-from { /* Vue 3: changed from .list-enter */
opacity: 0;
transform: scale(0.1);
}

.list-enter-to {
opacity: 1;
transform: translateX(0) scale(1);
}

.list-leave-active {
position: absolute; /* Keep this for smooth leave transitions if items reflow */
}

.list-leave-to {
opacity: 0;
transform: translateY(-50px) scale(0.01);
transform-origin: center;
}

.quick-view-container {
transition: height 0.5s ease;
}
</style>